import React from "react";

function CatThumbnail(props) {

  return (
    <div
      className="cat-container flex flex-column items-center pointer ma1 bg-white br2 shadow-2"
      onClick={() => {
        props.pickData(props.keyword)
      }}
    >
      <div className="cat-thumbnail">
        <img
          className="bg-white ba0 w-100 h-100"
          src={props.src}
          alt={props.title}
        ></img>
      </div>
      <p className="tc mt3-ns mb3-ns mt2 mb2 pt0">{props.title}</p>
    </div>
  );
}

export default CatThumbnail;
